module.exports = __webpack_public_path__ + "static/media/xrp.4e7cd710.svg";